import React from "react";
import { View, Pressable } from "react-native";
import { AppIcon, AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import { Popable } from "react-native-popable";
import { isElectronRunning } from "../../../../App";

const ChatMediaLeaf = ({
  onUploaded,
  url,
  type = "image",
  fileExtension = null,
  fileName = null,
}) => {
  const { currentTheme } = AppTheme.useTheme();

  const getTypeIcon = () => {
    if (type === "image") return AppAssets?.icons?.image;
    if (type === "video") return AppAssets?.icons?.video;
    if (type === "audio") return AppAssets?.icons?.audio;
    return AppAssets?.icons?.file;
  };

  const getDisplayText = () => {
    if (fileName) return fileName;
    if (fileExtension) return `.${fileExtension}`;
    return type;
  };

  const getFullFileName = () => {
    if (fileName && fileExtension) return `${fileName}.${fileExtension}`;
    if (fileName) return fileName;
    if (fileExtension) return `.${fileExtension}`;
    return type;
  };

  const handleOpen = () => {
    if (isElectronRunning()) {
      window.electronAPI.downloadFileDl(url, "_blank");
    } else {
      window.open(url, "_blank");
    }
  };

  return (
    <Popable
      content={getFullFileName()}
      action="hover"
      position="top"
      backgroundColor={currentTheme?.theme?.tooltipBackgroundColor}
      style={{
        zIndex: 20,
        maxWidth: 350,
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginHorizontal: 4,
          paddingHorizontal: 8,
          paddingVertical: 4,
          backgroundColor: currentTheme?.theme?.inputBackground,
          borderRadius: 6,
          borderWidth: 1,
          borderColor: currentTheme?.theme?.border,
          maxWidth: 400,
          overflow: "hidden",
        }}
      >
        <AppIcon
          icon={getTypeIcon()}
          size={14}
          color={currentTheme?.theme?.primary}
          wrapperStyle={{ marginRight: 6 }}
        />
        <AppText
          style={{
            fontSize: 11,
            color: currentTheme?.theme?.text,
            maxWidth: 280,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          numberOfLines={1}
          ellipsizeMode="middle"
          isClickable
          onPress={handleOpen}
          preventTranslation
        >
          {getDisplayText()}
        </AppText>

        <AppIcon
          icon={AppAssets?.icons?.close}
          size={12}
          color={currentTheme?.theme?.softText}
          wrapperStyle={{ marginLeft: 6 }}
          isClickable
          onPress={() => onUploaded(null)}
        />
      </View>
    </Popable>
  );
};

export default ChatMediaLeaf;
